import { z } from "zod";
// Login validation
export const loginSchema = z.object({
    userId: z.string().min(3, "Username must be at least 3 characters").max(50, "Username too long"),
    password: z
        .string()
        .min(3, "Password must be at least 3 characters")
        .max(100, "Password too long"),
});
// Check-in validation
export const checkInSchema = z
    .object({
    signalType: z.enum(["active_checkin", "passive_signal"]).optional().default("active_checkin"),
    message: z.string().max(1000, "Message too long").optional(),
    moodScore: z.number().min(1).max(10).optional(),
    moodLabels: z.array(z.string()).max(10).optional(), // Max 10 labels
    metadata: z.record(z.any()).optional(),
})
    .refine((data) => {
    // Validate metadata size (max 10KB when stringified)
    if (data.metadata) {
        const metadataSize = JSON.stringify(data.metadata).length;
        if (metadataSize > 10240) {
            // 10KB limit
            return false;
        }
    }
    return true;
}, {
    message: "Metadata too large (max 10KB)",
});
// User ID validation
export const userIdSchema = z.string().min(1, "User ID required").max(100, "User ID too long");
// Audit log query validation
export const auditQuerySchema = z.object({
    userId: z.string().optional(),
    limit: z.number().int().min(1).max(1000).optional().default(50),
    offset: z.number().int().min(0).optional().default(0),
});
// Generic validation helper
export function validateData(schema, data) {
    try {
        const result = schema.safeParse(data);
        if (result.success) {
            return { success: true, data: result.data };
        }
        else {
            const errorMessage = result.error.errors
                .map((err) => `${err.path.join(".")}: ${err.message}`)
                .join(", ");
            return { success: false, error: errorMessage };
        }
    }
    catch {
        return { success: false, error: "Validation failed" };
    }
}
//# sourceMappingURL=validation.js.map